import { Component, OnInit, Input} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';

//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { UserIdentity, LunaClaimValues, LunaClaimTypes } from '../../../../models/user-identity.model';
import { AuthService } from '../../../../services/auth.service';
import { OrganizationStub } from '../../../../common/models/organization.model';
import { Contact, ContactStub } from '../../../../admin/models/contact.model';
import { WorkOrderType } from '../../../../common/models/work-order.model';
import { DateService } from '../../../../common/services/date.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { DataCorrectionInstanceIndex, DataCorrectionInstanceIndexSearchSpec, DataCorrectionInstanceStatus } from '../../../../models/dataCorrection/dataCorrection.model';
import { DataCorrectionService } from '../../../../services/dataCorrection.service';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { WellService } from "../../../../common/services/well.service";
import { GroupSearchSpec, GroupService } from "../../../../admin/services/group.service";
import { ViewBase } from "../view-base";
import { Group } from "../../../../admin/models/group.model";
import { ElementRef, ViewChild } from '@angular/core';
import { ActionCellRendererComponent } from "../../../../common/components/ag-grid/action-cell-renderer.component";
import { ModalInfoComponent } from '../../../../common/components/ag-grid/modal-info.component';
import { TabComponent } from "../../../../common/components/tabs/tab.component";
import { ApplicationsService } from "../../../../applications/services/applications.service";
import { ApplicationState, BulkNAD83Data, WorkflowSearchSpec, ApplicationType, WorkflowData, WorkflowFieldData } from "../../../../applications/models/applications.models";
import { BulkWellStatusChangeSearchSpec, BulkWellStatusChangeStatus, BulkWellStatusChangeSearchResult, BulkWellStatusChange } from "../../../../admin/models/bulk-well-status-change.model";

@Component({
    selector: 'data-corrections-widget',
    templateUrl: './data-corrections-widget.component.html',
    styleUrls: ['./data-corrections-widget.component.scss'],
    standalone: false
})
export class DataCorrectionsWidgetComponent extends ViewBase implements OnInit {
    @Input() widgetTitle: string;

    allUsers: ContactStub[] = [];
    groups: Group[] = [];
    filteredUsers: ContactStub[] = [];
    get excelStyles(): any {
        return this._gridFormatterService.excelStyles;
    }
    @ViewChild("downloadLink") documentLink: ElementRef; 

	notSubmittedGridOptions: GridOptions;
	notSubmittedGridApi?: GridApi;
	pendingReviewGridOptions: GridOptions;
	pendingReviewGridApi?: GridApi;
	approvedGridOptions: GridOptions;
	approvedGridApi?: GridApi;
	returnedGridOptions: GridOptions;
	returnedGridApi?: GridApi;
	deniedGridOptions: GridOptions;
	deniedGridApi?: GridApi;
	pendingBulkStatusChangeGridOptions: GridOptions;
	pendingBulkStatusChangeGridApi?: GridApi;
	approvedBulkStatusChangeGridOptions: GridOptions;
	approvedBulkStatusChangeGridApi?: GridApi;
	rejectedBulkStatusChangeGridOptions: GridOptions;
	rejectedBulkStatusChangeGridApi?: GridApi;
	incompleteBulkNAD83GridOptions: GridOptions;
	incompleteBulkNAD83GridApi?: GridApi;
	pendingNAD83GridOptions: GridOptions;
	pendingNAD83GridApi?: GridApi;
	approvedNAD83GridOptions: GridOptions;
	approvedNAD83GridApi?: GridApi;
    orgStubs: OrganizationStub[];
    subscriptions: Subscription = new Subscription();
    notSubmittedDataCorrectionIndexes: DataCorrectionInstanceIndex[];
    pendingReviewDataCorrectionIndexes: DataCorrectionInstanceIndex[];
    approvedDataCorrectionIndexes: DataCorrectionInstanceIndex[];
    returnedDataCorrectionIndexes: DataCorrectionInstanceIndex[];
    deniedDataCorrectionIndexes: DataCorrectionInstanceIndex[];
    selectedItem: any;
    pendingBulkStatusChanges$: Observable<BulkWellStatusChangeSearchResult[]> = null;
    approvedBulkStatusChanges$: Observable<BulkWellStatusChangeSearchResult[]> = null;
	rejectedBulkStatusChanges$: Observable<BulkWellStatusChangeSearchResult[]> = null;
	incompleteBulkNAD83Update$: Observable<any[]> = null;
	pendingBulkNAD83Update$: Observable<any[]> = null;
	approvedBulkNAD83Update$: Observable<any[]> = null;


    public applicationNumberColumn = {
        headerClass: "wrapped",
        headerName: 'Application #',
        headerTooltip: 'Application #',
        field: 'dataCorrectionInstanceId',
        tooltipField: 'dataCorrectionInstanceId',
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: {
            openInNewWindow: false,
            textField: "dataCorrectionInstanceId",
            url: (data: DataCorrectionInstanceIndex) => {
                return `${this._router.parseUrl(this._router.url).root}admin/data-corrections/${data.dataCorrectionInstanceId}`;
            }
        },
        filter: 'agTextColumnFilter',
        filterParams: this._gridFormatterService.defaultTextFilterParams,
        minWidth: 160,
        maxWidth: 160
    } as ColDef;

    public notSubmittedApplicationNumberColumn = {
        headerClass: "wrapped",
        headerName: 'Application #',
        headerTooltip: 'Application #',
        field: 'dataCorrectionInstanceId',
        tooltipField: 'dataCorrectionInstanceId',
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: {
            openInNewWindow: false,
            textField: "dataCorrectionInstanceId",
            url: (data: DataCorrectionInstanceIndex) => {
                return `${this._router.parseUrl(this._router.url).root}admin/data-corrections/${data.dataCorrectionInstanceId}`;
            },
            enabled: (data: DataCorrectionInstanceIndex) => {
                return data.createdByUserId == this.authService.User.id;
            },
        },
        filter: 'agTextColumnFilter',
        filterParams: this._gridFormatterService.defaultTextFilterParams,
        minWidth: 160,
        maxWidth: 160
    } as ColDef;

    public organizationColumn = {
        headerClass: "wrapped",
        headerName: 'Company',
        headerTooltip: 'Company',
        field: 'objectOrganizationName',
        tooltipField: 'objectOrganizationName',
        filter: 'agTextColumnFilter',
        filterParams: this._gridFormatterService.defaultTextFilterParams,
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    public entityTypeColumn = {
        headerClass: "wrapped",
        headerName: 'Entity Type',
        headerTooltip: 'Entity Type',
        field: 'entityName',
        tooltipField: 'entityName',
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    public statusColumn = {
        headerClass: "wrapped",
        headerName: 'Status',
        headerTooltip: 'Status',
        field: 'status',
        tooltipField: 'status',
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    public objectIdColumn = {
        headerClass: "wrapped",
        headerName: 'Identifier',
        headerTooltip: 'Identifier',
        field: 'objectId',
        tooltipField: 'objectId',
        filter: 'agTextColumnFilter',
        filterParams: this._gridFormatterService.defaultTextFilterParams,
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    public externalApplicationIdColumn = {
        headerClass: "wrapped",
        headerName: 'External Application #',
        headerTooltip: 'External Application Id',
        field: 'externalRequestApplicationId',
        tooltipField: 'externalRequestApplicationId',
        filter: 'agTextColumnFilter',
        filterParams: this._gridFormatterService.defaultTextFilterParams,
        minWidth: 210,
        maxWidth: 250
    } as ColDef;

    public createdDateColumn = {
        headerClass: "wrapped",
        headerName: 'Created',
        headerTooltip: 'Created',
        field: 'createdDate',
        tooltipValueGetter: this._gridFormatterService.formatDate('createdDate'),
        valueFormatter: this._gridFormatterService.formatDate('createdDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this._gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
        maxWidth: 135,
    } as ColDef;

    public submittedDateColumn = {
        headerClass: "wrapped",
        headerName: 'Submitted',
        headerTooltip: 'Submitted',
        field: 'submittedDate',
        tooltipValueGetter: this._gridFormatterService.formatDate('submittedDate'),
        valueFormatter: this._gridFormatterService.formatDate('submittedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this._gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
        maxWidth: 135,
    } as ColDef;

    public approvedDateColumn = {
        headerClass: "wrapped",
        headerName: 'Approved',
        headerTooltip: 'Approved',
        field: 'approvedDate',
        tooltipValueGetter: this._gridFormatterService.formatDate('approvedDate'),
        valueFormatter: this._gridFormatterService.formatDate('approvedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this._gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
        maxWidth: 135,
    } as ColDef;

    public deniedDateColumn = {
        headerClass: "wrapped",
        headerName: 'Denied',
        headerTooltip: 'Denied',
        field: 'deniedDate',
        tooltipValueGetter: this._gridFormatterService.formatDate('deniedDate'),
        valueFormatter: this._gridFormatterService.formatDate('deniedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this._gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
        maxWidth: 135,
    } as ColDef;

    public returnedDateColumn = {
        headerClass: "wrapped",
        headerName: 'Returned',
        headerTooltip: 'Returned',
        field: 'returnedDate',
        tooltipValueGetter: this._gridFormatterService.formatDate('returnedDate'),
        valueFormatter: this._gridFormatterService.formatDate('returnedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this._gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
        maxWidth: 135,
    } as ColDef;

    public columnDefs: ColDef[] = [
        this.createdDateColumn,
        this.notSubmittedApplicationNumberColumn,
        this.externalApplicationIdColumn,
        this.organizationColumn,
        this.entityTypeColumn,
        this.statusColumn,
        this.objectIdColumn
    ];

    public notSubmittedColumns: ColDef[] = [
        this.createdDateColumn,
        this.notSubmittedApplicationNumberColumn,
        this.externalApplicationIdColumn,
        this.organizationColumn,
        this.entityTypeColumn,
        this.statusColumn,
        this.objectIdColumn
    ];
    public pendingReviewColumns: ColDef[] = [
        this.createdDateColumn,
        this.submittedDateColumn,
        this.applicationNumberColumn,
        this.externalApplicationIdColumn,
        {
            headerClass: "wrapped",
            headerName: "Assignee",
            headerTooltip: "Assignee",
            tooltipField: "assignedToUserId",
            field: "assignedToUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.filteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedToUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedToUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 140,
            maxWidth: 150
        },
        this.organizationColumn,
        this.entityTypeColumn,
        this.statusColumn,
        this.objectIdColumn];
    public approvedReviewColumns: ColDef[] = [this.createdDateColumn, this.approvedDateColumn, this.applicationNumberColumn, this.externalApplicationIdColumn, this.organizationColumn, this.entityTypeColumn, this.statusColumn, this.objectIdColumn];
    public deniedReviewColumns: ColDef[] = [this.createdDateColumn, this.deniedDateColumn, this.applicationNumberColumn, this.externalApplicationIdColumn, this.organizationColumn, this.entityTypeColumn, this.statusColumn, this.objectIdColumn];
    public returnedReviewColumns: ColDef[] = [this.createdDateColumn, this.returnedDateColumn, this.applicationNumberColumn, this.externalApplicationIdColumn, this.organizationColumn, this.entityTypeColumn, this.statusColumn, this.objectIdColumn];

    pendingBulkStatusChangeColumns: ColDef[] = [
        {
            headerClass: "wrapped",
            headerName: "Request ID",
            headerTooltip: "Request ID",
            field: "requestId",
            tooltipField: "requestId",
            rowGroup: true,
            hide: false,
            showRowGroup: true,
            minWidth: 150,
            maxWidth: 150,
            cellRendererSelector: (params) => {
                if (this.canApproveBulkStatusChanges()) {
                    return {
                        component: RouterLinkRendererComponent,
                        params: {
                            textField: "requestId",
                            url: (data: BulkWellStatusChangeSearchResult) => { return `/admin/bulk-well-status-update/${data.requestId}` }
                        }
                    }
                } else {
                    return {
                        component: ModalInfoComponent,
                        params: {
                            text: (params) => { return params.requestId; },
                            modalText: (params) => {
                                return "You do not have permission to approve this application.";
                            }
                        }
                    }
                }
            },
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Date Requested",
            headerTooltip: "Date Requested",
            field: "dateRequested",
            valueFormatter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
            tooltipValueGetter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
            maxWidth: 135,
            minWidth: 125,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "API #",
            headerTooltip: "API #",
            field: "apiNumber",
            tooltipField: "apiNumber",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            cellClass: "string"
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Well Name",
            headerTooltip: "Well Name",
            field: "wellName",
            tooltipField: "wellName",
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Well Number",
            headerTooltip: "Well Number",
            field: "wellNumber",
            tooltipField: "wellNumber",
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "From Well Status",
            headerTooltip: "From Well Status",
            field: "fromWellStatus",
            tooltipField: "fromWellStatus",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 120,
            maxWidth: 120
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Disposition",
            headerTooltip: "To Disposition",
            field: "toDisposition",
            tooltipField: "toDisposition",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 125,
            maxWidth: 135
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Status Reason",
            headerTooltip: "To Status Reason",
            field: "toStatusReason",
            tooltipField: "toStatusReason",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 110
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Well Type Description",
            headerTooltip: "To Well Type Description",
            field: "toTypeDescription",
            tooltipField: "toTypeDescription",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 125,
            maxWidth: 135
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Map Symbol",
            headerTooltip: "Map Symbol",
            field: "mapSymbol",
            tooltipField: "mapSymbol",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 110
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "New Status Date",
            headerTooltip: "New Status Date",
            field: "toStatusDate",
            tooltipValueGetter: this.formatDate("toStatusDate", true),
            valueFormatter: this.formatDate("toStatusDate", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 100,
            minWidth: 100
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Date Uploaded",
            headerTooltip: "Date Uploaded",
            field: "dateUploaded",
            tooltipValueGetter: this.formatDate("dateUploaded", true),
            valueFormatter: this.formatDate("dateUploaded", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 135,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Requested By",
            headerTooltip: "Requested By",
            field: "requestedByName",
            tooltipField: "requestedByName",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 300
        } as ColDef
    ] as ColDef[];

    approvedBulkStatusChangeColumns: ColDef[] = [
        {
            headerClass: "wrapped",
            headerName: "Request ID",
            headerTooltip: "Request ID",
            field: "requestId",
            tooltipField: "requestId",
            rowGroup: true,
            showRowGroup: true,
            hide: false,
            minWidth: 100,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
         {
            headerClass: "wrapped",
            headerName: "Date Approved",
            headerTooltip: "Date Approved",
            field: "dateApproved",
            valueFormatter: this._gridFormatterService.formatDate("dateApproved", "MM/dd/yyyy", "N/A"),
            tooltipValueGetter: this._gridFormatterService.formatDate("dateApproved", "MM/dd/yyyy", "N/A"),
            maxWidth: 125,
            minWidth: 135,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Approved By",
            headerTooltip: "Approved By",
            field: "approvedByName",
            tooltipField: "approvedByName",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 150,
            maxWidth: 175
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "API #",
            headerTooltip: "API #",
            field: "apiNumber",
            tooltipField: "apiNumber",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            cellClass: "string"
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Well Name",
            headerTooltip: "Well Name",
            field: "wellName",
            tooltipField: "wellName",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Well Number",
            headerTooltip: "Well Number",
            field: "wellNumber",
            tooltipField: "wellNumber",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "From Well Status",
            headerTooltip: "From Well Status",
            field: "fromWellStatus",
            tooltipField: "fromWellStatus",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 120,
            maxWidth: 120
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "From Status Date",
            headerTooltip: "From Status Date",
            field: "fromStatusDate",
            tooltipValueGetter: this.formatDate("fromStatusDate", true),
            valueFormatter: this.formatDate("fromStatusDate", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 110,
            minWidth: 110,
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Disposition",
            headerTooltip: "To Disposition",
            field: "toDisposition",
            tooltipField: "toDisposition",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 135,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Status Reason",
            headerTooltip: "To Status Reason",
            field: "toStatusReason",
            tooltipField: "toStatusReason",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 110
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Well Type Description",
            headerTooltip: "To Well Type Description",
            field: "toTypeDescription",
            tooltipField: "toTypeDescription",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 135,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Map Symbol",
            headerTooltip: "Map Symbol",
            field: "mapSymbol",
            tooltipField: "mapSymbol",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 110
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "New Status Date",
            headerTooltip: "New Status Date",
            field: "toStatusDate",
            tooltipValueGetter: this.formatDate("toStatusDate", true),
            valueFormatter: this.formatDate("toStatusDate", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 110,
            minWidth: 110,
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Date Uploaded",
            headerTooltip: "Date Uploaded",
            field: "dateUploaded",
            tooltipValueGetter: this.formatDate("dateUploaded", true),
            valueFormatter: this.formatDate("dateUploaded", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 135,
            minWidth: 125,
        } as ColDef
    ] as ColDef[];

    rejectedBulkStatusChangeColumns: ColDef[] = [
        {
            headerClass: "wrapped",
            headerName: "Request ID",
            headerTooltip: "Request ID",
            field: "requestId",
            tooltipField: "requestId",
            rowGroup: true,
            showRowGroup: true,
            hide: false,
            minWidth: 100,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Date Denied",
            headerTooltip: "Date Denied",
            field: "dateRejected",
            valueFormatter: this._gridFormatterService.formatDate("dateRejected", "MM/dd/yyyy", "N/A"),
            tooltipValueGetter: this._gridFormatterService.formatDate("dateRejected", "MM/dd/yyyy", "N/A"),
            maxWidth: 110,
            minWidth: 110,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Denied By",
            headerTooltip: "Denied By",
            field: "rejectedByName",
            tooltipField: "rejectedByName",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 150
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "API #",
            headerTooltip: "API #",
            field: "apiNumber",
            tooltipField: "apiNumber",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            cellClass: "string"
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Well Name",
            headerTooltip: "Well Name",
            field: "wellName",
            tooltipField: "wellName",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Well Number",
            headerTooltip: "Well Number",
            field: "wellNumber",
            tooltipField: "wellNumber",
            minWidth: 125,
            maxWidth: 125,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "From Well Status",
            headerTooltip: "From Well Status",
            field: "fromWellStatus",
            tooltipField: "fromWellStatus",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            minWidth: 120,
            maxWidth: 120
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "From Status Date",
            headerTooltip: "From Status Date",
            field: "fromStatusDate",
            tooltipValueGetter: this.formatDate("fromStatusDate", true),
            valueFormatter: this.formatDate("fromStatusDate", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 110,
            minWidth: 110,
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Disposition",
            headerTooltip: "To Disposition",
            field: "toDisposition",
            tooltipField: "toDisposition",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 135,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Status Reason",
            headerTooltip: "To Status Reason",
            field: "toStatusReason",
            tooltipField: "toStatusReason",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 110
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "To Well Type Description",
            headerTooltip: "To Well Type Description",
            field: "toTypeDescription",
            tooltipField: "toTypeDescription",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 135,
            minWidth: 125
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Map Symbol",
            headerTooltip: "Map Symbol",
            field: "mapSymbol",
            tooltipField: "mapSymbol",
            suppressMovable: true,
            filter: "agTextColumnFilter",
            filterParams: this._gridFormatterService.defaultTextFilterParams,
            maxWidth: 110
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "New Status Date",
            headerTooltip: "New Status Date",
            field: "toStatusDate",
            tooltipValueGetter: this.formatDate("toStatusDate", true),
            valueFormatter: this.formatDate("toStatusDate", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 110,
            minWidth: 110,
        } as ColDef,
        {
            headerClass: "wrapped",
            headerName: "Date Uploaded",
            headerTooltip: "Date Uploaded",
            field: "dateUploaded",
            tooltipValueGetter: this.formatDate("dateUploaded", true),
            valueFormatter: this.formatDate("dateUploaded", true),
            suppressMovable: true,
            filter: "agDateColumnFilter",
            filterParams: this._gridFormatterService.defaultDateFilterParams,
            maxWidth: 135,
            minWidth: 130,
        } as ColDef
    ] as ColDef[];

	incompleteBulkNAD83Columns: ColDef[] = [
		{
			headerClass: "wrapped",
			headerName: "Application #",
			headerTooltip: "Application #",
			field: "applicationNumber",
			tooltipField: "applicationNumber",
			rowGroup: true,
			hide: false,
			showRowGroup: true,
			minWidth: 150,
			maxWidth: 150,
			cellRenderer: RouterLinkRendererComponent,
			cellRendererParams: {
				openInNewWindow: false,
				textField: "applicationNumber",
				url: (data: any) => {
					let url = `${this._router.parseUrl(this._router.url).root}admin/bulk-nad83-update/${data.applicationNumber}`;
					console.log('selected url', url);
					return url;
				}
			},
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "Date Requested",
			headerTooltip: "Date Requested",
			field: "dateRequested",
			valueFormatter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
			tooltipValueGetter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
			maxWidth: 135,
			minWidth: 130,
			filter: "agDateColumnFilter",
			filterParams: this._gridFormatterService.defaultDateFilterParams
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "API #",
			headerTooltip: "API #",
			field: "apiNumber",
			tooltipField: "apiNumber",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 125,
			minWidth: 125
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "County Name",
			headerTooltip: "County Name",
			field: "countyName",
			tooltipField: "countyName",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "From Latitude 83",
			headerTooltip: "From Latitude 83",
			field: "fromLatitude83",
			tooltipField: "fromLatitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 110,
            minWIdth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "To Latitude 83",
			headerTooltip: "To Latitude 83",
			field: "latitude83",
			tooltipField: "latitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "From Longitude 83",
			headerTooltip: "From Longitude 83",
			field: "fromLongitude83",
			tooltipField: "fromLongitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 125,
            minWidth: 115
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "To Longitude 83",
			headerTooltip: "To Longitude 83",
			field: "longitude83",
			tooltipField: "longitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 125,
            minWidth: 115
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "Source of Location",
			headerTooltip: "Source of Location",
			field: "sourceOfLocation",
			tooltipField: "sourceOfLocation",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 135,
            minWidth: 125
		} as ColDef,

	] as ColDef[];

	pendingBulkNAD83Columns: ColDef[] = [
		{
			headerClass: "wrapped",
			headerName: "Application #",
			headerTooltip: "Application #",
			field: "applicationNumber",
			tooltipField: "applicationNumber",
			rowGroup: true,
			hide: false,
			showRowGroup: true,
			minWidth: 150,
			maxWidth: 150,
			cellRenderer: RouterLinkRendererComponent,
			cellRendererParams: {
				openInNewWindow: false,
				textField: "applicationNumber",
				url: (data: any) => {
					return `${this._router.parseUrl(this._router.url).root}admin/bulk-nad83-update/review/${data.applicationNumber}`;
				}
			},
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "Date Requested",
			headerTooltip: "Date Requested",
			field: "dateRequested",
			valueFormatter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
			tooltipValueGetter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
			maxWidth: 135,
			minWidth: 135,
			filter: "agDateColumnFilter",
			filterParams: this._gridFormatterService.defaultDateFilterParams
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "API #",
			headerTooltip: "API #",
			field: "apiNumber",
			tooltipField: "apiNumber",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 125,
			minWidth: 125
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "County Name",
			headerTooltip: "County Name",
			field: "countyName",
			tooltipField: "countyName",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "From Latitude 83",
			headerTooltip: "From Latitude 83",
			field: "fromLatitude83",
			tooltipField: "fromLatitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "To Latitude 83",
			headerTooltip: "To Latitude 83",
			field: "latitude83",
			tooltipField: "latitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "From Longitude 83",
			headerTooltip: "From Longitude 83",
			field: "fromLongitude83",
			tooltipField: "fromLongitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 125,
            minWidth: 115
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "To Longitude 83",
			headerTooltip: "To Longitude 83",
			field: "longitude83",
			tooltipField: "longitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 125,
            minWidth: 115
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "Source of Location",
			headerTooltip: "Source of Location",
			field: "sourceOfLocation",
			tooltipField: "sourceOfLocation",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 135,
            minWidth: 125
		} as ColDef
	] as ColDef[];

	approvedBulkNAD83Columns: ColDef[] = [
		{
			headerClass: "wrapped",
			headerName: "Application #",
			headerTooltip: "Application #",
			field: "applicationNumber",
			tooltipField: "applicationNumber",
			rowGroup: true,
			hide: false,
			showRowGroup: true,
			minWidth: 150,
			maxWidth: 150,
			cellRenderer: RouterLinkRendererComponent,
			cellRendererParams: {
				openInNewWindow: false,
				textField: "applicationNumber",
				url: (data: any) => {
					return `${this._router.parseUrl(this._router.url).root}admin/bulk-nad83-update/complete/${data.applicationNumber}`;
				}
			},
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "Date Requested",
			headerTooltip: "Date Requested",
			field: "dateRequested",
			valueFormatter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
			tooltipValueGetter: this._gridFormatterService.formatDate("dateRequested", "MM/dd/yyyy", "N/A"),
			maxWidth: 145,
			minWidth: 140,
			filter: "agDateColumnFilter",
			filterParams: this._gridFormatterService.defaultDateFilterParams
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "API #",
			headerTooltip: "API #",
			field: "apiNumber",
			tooltipField: "apiNumber",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 125,
			minWidth: 125
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "County Name",
			headerTooltip: "County Name",
			field: "countyName",
			tooltipField: "countyName",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "From Latitude 83",
			headerTooltip: "From Latitude 83",
			field: "fromLatitude83",
			tooltipField: "fromLatitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "To Latitude 83",
			headerTooltip: "To Latitude 83",
			field: "latitude83",
			tooltipField: "latitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 110,
            minWidth: 100
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "From Longitude 83",
			headerTooltip: "From Longitude 83",
			field: "fromLongitude83",
			tooltipField: "fromLongitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 135,
            minWidth: 125
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "To Longitude 83",
			headerTooltip: "To Longitude 83",
			field: "longitude83",
			tooltipField: "longitude83",
			suppressMovable: true,
			filter: "agNumberColumnFilter",
			filterParams: this._gridFormatterService.defaultNumberFilterParams,
			maxWidth: 135,
            minWidth: 125
		} as ColDef,
		{
			headerClass: "wrapped",
			headerName: "Source of Location",
			headerTooltip: "Source of Location",
			field: "sourceOfLocation",
			tooltipField: "sourceOfLocation",
			suppressMovable: true,
			filter: "agTextColumnFilter",
			filterParams: this._gridFormatterService.defaultTextFilterParams,
			maxWidth: 135,
            minWidth: 125
		} as ColDef
	] as ColDef[];

	get showIncompleteBulkNAD83(): boolean {
		return this.authService != null && this.authService.User != null && this.authService.User.hasPermission(LunaClaimTypes.System, LunaClaimValues.BulkUploadNAD83LatLong);
	}

	get showPendingBulkNAD83(): boolean {
		return this.authService != null && this.authService.User != null && this.authService.User.hasPermission(LunaClaimTypes.System, LunaClaimValues.ApproveBulkUploadNad83LatLong);
	}



    constructor(
        public authService: AuthService,
        public datePipe: DatePipe,
        public dataCorrectionService: DataCorrectionService,
        public _gridFormatterService: GridFormatterService,
        private _router: Router,
        public dateService: DateService,
        public groupService: GroupService,
		public wellService: WellService,
		private _appService: ApplicationsService
    ) {
        super("ViewDataCorrectionsWidget", [LunaClaimValues.ViewDataCorrectionsWidget]);
    }

    ngOnInit() {

        this.setGridOptions();
		this.notSubmittedGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.notSubmittedColumns);
		this.notSubmittedGridOptions.onGridReady = (params) => { this.notSubmittedGridApi = params.api; };
		this.approvedGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.approvedReviewColumns);
		this.approvedGridOptions.onGridReady = (params) => { this.approvedGridApi = params.api; };
		this.deniedGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.deniedReviewColumns);
		this.deniedGridOptions.onGridReady = (params) => { this.deniedGridApi = params.api; };
		this.returnedGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.returnedReviewColumns);
		this.returnedGridOptions.onGridReady = (params) => { this.returnedGridApi = params.api; };
        this.approvedBulkStatusChangeGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.approvedBulkStatusChangeColumns);
		this.approvedBulkStatusChangeGridOptions.groupDisplayType = "groupRows";
        this.approvedBulkStatusChangeGridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading ...</span>';
		this.approvedBulkStatusChangeGridOptions.headerHeight = 50;
		this.approvedBulkStatusChangeGridOptions.onGridReady = (params) => { this.approvedBulkStatusChangeGridApi = params.api; };
        this.pendingBulkStatusChangeGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.pendingBulkStatusChangeColumns);
		this.pendingBulkStatusChangeGridOptions.groupDisplayType = "groupRows";
        this.pendingBulkStatusChangeGridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading ...</span>';
		this.pendingBulkStatusChangeGridOptions.headerHeight = 50;
		this.pendingBulkStatusChangeGridOptions.onGridReady = (params) => { this.pendingBulkStatusChangeGridApi = params.api; };
        this.rejectedBulkStatusChangeGridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.rejectedBulkStatusChangeColumns);
		this.rejectedBulkStatusChangeGridOptions.groupDisplayType = "groupRows";
        this.rejectedBulkStatusChangeGridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading ...</span>';
		this.rejectedBulkStatusChangeGridOptions.headerHeight = 50;
		this.rejectedBulkStatusChangeGridOptions.onGridReady = (params) => { this.rejectedBulkStatusChangeGridApi = params.api; };
		this.incompleteBulkNAD83GridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.incompleteBulkNAD83Columns);
		this.incompleteBulkNAD83GridOptions.groupDisplayType = "groupRows";
		this.incompleteBulkNAD83GridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading ...</span>';
		this.incompleteBulkNAD83GridOptions.headerHeight = 50;
		this.incompleteBulkNAD83GridOptions.onGridReady = (params) => { this.incompleteBulkNAD83GridApi = params.api; };
		this.pendingNAD83GridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.pendingBulkNAD83Columns);
		this.pendingNAD83GridOptions.groupDisplayType = "groupRows";
		this.pendingNAD83GridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading ...</span>';
		this.pendingNAD83GridOptions.headerHeight = 50;
		this.pendingNAD83GridOptions.onGridReady = (params) => { this.pendingNAD83GridApi = params.api; };
		this.approvedNAD83GridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.approvedBulkNAD83Columns);
		this.approvedNAD83GridOptions.groupDisplayType = "groupRows";
		this.approvedNAD83GridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading ...</span>';
		this.approvedNAD83GridOptions.headerHeight = 50;
		this.approvedNAD83GridOptions.onGridReady = (params) => { this.approvedNAD83GridApi = params.api; };
		this.refreshData();
        this._router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    assign(params: any): any {
        let result: boolean = false;
        if (params && params.newValue && params.newValue.id) {
            if (params.newValue.id != "-1") {
                params.data.assignedToUserId = params.newValue.id;
            } else {
                params.data.assignedToUserId = "";
            }
            if (params.context && params.context.componentParent) {
                let parent = <DataCorrectionsWidgetComponent>params.context.componentParent;
                let selectedItem = parent.allUsers.find(u => u.id == params.newValue.id);
                if (selectedItem) {
                    params.data.assignedUserName = selectedItem.displayName;
                }
            }
            result = true;
        }
        return result;
    }

    buildColumns(): ColDef[] {
        let colDefs: ColDef[] = [];
        colDefs.push(this.createdDateColumn);
        colDefs.push(this.notSubmittedApplicationNumberColumn);
        colDefs.push(this.externalApplicationIdColumn);
        colDefs.push({
            headerClass: "wrapped",
            headerName: "Assignee",
            headerTooltip: "Assignee",
            field: "assignedToUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.filteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedToUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedToUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 140
        } as ColDef);
        colDefs.push(this.organizationColumn);
        colDefs.push(this.entityTypeColumn);
        colDefs.push(this.statusColumn);
        colDefs.push(this.objectIdColumn);
        this._gridFormatterService.applyFilterKeyboardHintTooltips(colDefs);
        return colDefs;
    }

    canApproveBulkStatusChanges(): boolean {
        if (this.authService.User == null) return false;
        return this.authService.hasSystemPermission(LunaClaimValues.ApproveBulkWellStatusChanges) != null;
    }

    cellValueChanged(params: any): void {
        if (params.api) {
            params.api.refreshCells();
        }
    }

    formatDate(field: string, formatted: boolean): any {
        return (obj: any) => {
            let date: Date = null;
            if (obj != null && obj.data != null && obj.data[field] != null) {
                date = <Date>obj.data[field];
            }
            if (formatted) {
                if (date != null) {
                    return this.datePipe.transform(date, "MM/dd/yyyy", '+0000');
                }
                return "N/A";
            }
            return date;
        }
    }

    getBulkWellStatusChanges(status: BulkWellStatusChangeStatus): Observable<BulkWellStatusChangeSearchResult[]> {
        let spec: BulkWellStatusChangeSearchSpec = {
            changeId: "",
            status: [ status ]
        } as BulkWellStatusChangeSearchSpec;
        return this.wellService.searchBulkWellStatusChanges(spec).pipe(
            map((data: BulkWellStatusChange[]) => {
                const results: BulkWellStatusChangeSearchResult[] = [];
                data.forEach(b => {
                    b.bulkWellStatusChangeDetails.forEach(d => {
                        let result: BulkWellStatusChangeSearchResult = {
                            requestId: d.requestId,
                            dateRequested: b.dateRequested,
                            requestedById: b.requestedById,
                            requestedByName: b.requestedByName,
                            approvedById: b.approvedById,
                            approvedByName: b.approvedByName,
                            dateApproved: b.dateApproved,
                            rejectedById: b.rejectedById,
                            rejectedByName: b.rejectedByName,
                            dateRejected: b.dateRejected,
                            apiNumber: d.apiNumber,
                            wellName: d.wellName,
                            wellNumber: d.wellNumber,
                            fromWellStatus: d.fromWellStatus,
                            toDisposition: d.toDisposition,
                            toStatusReason: d.toStatusReason,
                            toTypeDescription: d.toTypeDescription,
                            toStatusDate: d.toStatusDate,
                            mapSymbol: d.mapSymbol,
                            dateUploaded: d.dateUploaded,
                            notes: d.notes
                        } as BulkWellStatusChangeSearchResult;
                        results.push(result);
                    });

                })
                return results;
            })
        );
	}

	getIncompleteBulkNAD83Changes(): Observable<any[]> {
		return this.getBulkNAD83Changes([ApplicationState.Input, ApplicationState.Start]);
	}

	getPendingBulkNAD83Changes(): Observable<any[]> {
		return this.getBulkNAD83Changes([ApplicationState.InitialReview]);
	}

	getApprovedBulkNAD83Changes(): Observable<any[]> {
		return this.getBulkNAD83Changes([ApplicationState.Approved]);
	}

	getBulkNAD83Changes(states: ApplicationState[]): Observable<any[]> {
		let spec: WorkflowSearchSpec = {
			applicationStates : states,
			applicationTypes: [ApplicationType.BulkNAD83Update]
		} as WorkflowSearchSpec;
		return this._appService.searchApplications(spec).pipe(
			map((apps: WorkflowData[]) => {
				let data: any[] = [];
				apps.forEach(app => {
					if (app.workflowFieldDatas != null && app.workflowFieldDatas.length > 0) {
						let uploadField = app.workflowFieldDatas.find(d => d.formControlName === 'parsedData');
						if (uploadField != null && uploadField.stringData != null) {
							let rowData: BulkNAD83Data[] = JSON.parse(uploadField.stringData);
							rowData.forEach(r => {
								let item = {
									applicationNumber: app.applicationNumber,
									dateRequested: app.lastModifiedDate,
									requestedBy: app.lastModifiedBy,
									apiNumber: r.apiNumber,
									countyCode: r.countyCode,
									countyName: r.countyName,
									fromLatitude83: r.fromLatitude83,
									fromLongitude83: r.fromLongitude83,
									latitude83: r.latitude83,
									longitude83: r.longitude83,
									line: r.line,
									sourceOfLocation: r.sourceOfLocation
								};
								data.push(item);
							})
						}
					} else {
						let item = {
							applicationNumber: app.applicationNumber,
							dateRequested: app.lastModifiedDate,
							requestedBy: app.lastModifiedBy,
							apiNumber: "",
							countyCode: "",
							countyName: "",
							fromLatitude83: null,
							fromLongitude83: null,
							latitude83: null,
							longitude83: null,
							line: null,
							sourceOfLocation: null
						};
						data.push(item);
					}
					
				});
				return data;
			})
		)
	}

    buildUserList(groups: Group[]): ContactStub[] {
        let userList: ContactStub[] = [];
        groups.forEach(u => userList = userList.concat(u.users));
        userList = this.filterUniqueUsers(userList);
        userList = this.sortUsers(userList);
        userList.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
        return userList;
    }

    filterUniqueUsers(users: ContactStub[]): ContactStub[] {
        return users.filter((user, i, arr) => arr.findIndex(t => t.id === user.id) === i);
    }

    renderUserDropdownOptions(params: any): string {
        let returnValue = params && params.value && params.value.displayName ? params.value.displayName : "Unassigned";
        return returnValue;
    }

    renderAssignedUser(params: any): string {
        return params?.value?.displayName ?? "Unassigned";
    }

    saveAssignments(event: any): void {
        const row = event.data as DataCorrectionInstanceIndex;
        const userId: string | null = row?.assignedToUserId || null;
        if (!row?.dataCorrectionInstanceId) return;
        const sub$ = this.dataCorrectionService.assignDataCorrectionInstance(row.dataCorrectionInstanceId, userId)
            .subscribe({
                next: () => { },
                error: (error: any) => { console.error(error); }
            });
        this.subscriptions.add(sub$);
    }

    setGridOptions(): void {
        this.pendingReviewGridOptions = <GridOptions>{
            columnDefs: this.buildColumns(),
            context: {
                componentParent: this
            },
            defaultColDef: { filter: true, resizable: true, sortable: true, editable: true } as ColDef,
            headerHeight: 50,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            onCellValueChanged: ($event) => this.saveAssignments($event),
            pagination: true,
            paginationAutoPageSize: true,
			suppressHorizontalScroll: false,
			onGridReady: (params) => { this.pendingReviewGridApi = params.api; }
        };
    }

    dateFormatter(component: any, field: string) {
        return (obj: any) => {
            let returnValue = '';
            try {
                returnValue = obj.data[field] ? component.datePipe.transform(obj.data[field], 'MM/dd/yyyy') : '';
            }
            catch {
            }
            return returnValue;
        }
    }

    sortUsers(users: ContactStub[]): ContactStub[] {
        return users.sort((a, b) => {
            if (a.firstName > b.firstName) return 1;
            if (a.firstName < b.firstName) return -1;
            if (a.firstName == b.firstName) {
                if (a.lastName > b.lastName) return 1;
                if (a.lastName < b.lastName) return -1;
            }
            return 0;
        })
    }

    get isAdhoc(): boolean {
        return this.selectedItem.type === WorkOrderType.AdHoc;
    }

    onTabClicked(tab: TabComponent): void {
        if (tab != null) {
            switch (tab.title) {
                case "Pending Bulk Well Status Changes":
                    this.approvedBulkStatusChanges$ = null;
                    this.rejectedBulkStatusChanges$ = null;
                    this.pendingBulkStatusChangeGridApi?.setGridOption("loading", true);
                    this.pendingBulkStatusChanges$ = this.getBulkWellStatusChanges(BulkWellStatusChangeStatus.Pending).pipe(
                        tap(() => this.pendingBulkStatusChangeGridApi?.setGridOption("loading", false))
                    );
                    break;
                case "Approved Bulk Well Status Changes":
                    this.pendingBulkStatusChanges$ = null;
                    this.rejectedBulkStatusChanges$ = null;
                    this.approvedBulkStatusChangeGridApi?.setGridOption("loading", true);
                    this.approvedBulkStatusChanges$ = this.getBulkWellStatusChanges(BulkWellStatusChangeStatus.Approved).pipe(
                        tap(() => this.approvedBulkStatusChangeGridApi?.setGridOption("loading", false))
                    );
                    break;
                case "Denied Bulk Well Status Changes":
                    this.approvedBulkStatusChanges$ = null;
                    this.pendingBulkStatusChanges$ = null;
                    this.rejectedBulkStatusChangeGridApi?.setGridOption("loading", true);
                    this.rejectedBulkStatusChanges$ = this.getBulkWellStatusChanges(BulkWellStatusChangeStatus.Rejected).pipe(
                        tap(() => this.rejectedBulkStatusChangeGridApi?.setGridOption("loading", false))
                    );
					break;
				case "Incomplete Bulk NAD83 Changes":
					this.pendingBulkNAD83Update$ = null;
					this.approvedBulkNAD83Update$ = null;
					this.incompleteBulkNAD83GridApi?.setGridOption("loading", true);
					this.incompleteBulkNAD83Update$ = this.getIncompleteBulkNAD83Changes().pipe(
						tap(() => this.incompleteBulkNAD83GridApi?.setGridOption("loading", false))
					);
					break;
				case "Pending Bulk NAD83 Changes":
					this.incompleteBulkNAD83Update$ = null;
					this.approvedBulkNAD83Update$ = null;
					this.pendingNAD83GridApi?.setGridOption("loading", true);
					this.pendingBulkNAD83Update$ = this.getPendingBulkNAD83Changes().pipe(
						tap(() => this.pendingNAD83GridApi?.setGridOption("loading", false))
					);
					break;
				case "Approved Bulk NAD83 Changes":
					this.incompleteBulkNAD83Update$ = null;
					this.pendingBulkNAD83Update$ = null;
					this.approvedNAD83GridApi?.setGridOption("loading", true);
					this.approvedBulkNAD83Update$ = this.getApprovedBulkNAD83Changes().pipe(
						tap(() => this.approvedNAD83GridApi?.setGridOption("loading", false))
					);
					break;
            }
        }
    }

    defaultSort(instances: DataCorrectionInstanceIndex[]): DataCorrectionInstanceIndex[] {
        return instances.sort((a, b) => {
            if (a.createdDate < b.createdDate) return -1;
            if (a.createdDate > b.createdDate) return 1;
            return 0;
        });
    }

    refreshData(): void {
        this.showLoadingOverlays(true);

        const groups$ = this.groupService.get({ internal: true, stubs: false, fullContactDetails: true } as GroupSearchSpec);
        const data$ = this.dataCorrectionService.getDataCorrectionInstanceIndexes({} as DataCorrectionInstanceIndexSearchSpec);

        const sub$ = forkJoin([groups$, data$]).subscribe({
            next: ([groupData, data]: [any, DataCorrectionInstanceIndex[]]) => {
                this.allUsers = [];
                this.filteredUsers = [];
                if (groupData instanceof Array) {
                    this.groups = groupData as Group[];
                    this.groups.forEach(g => this.allUsers = this.allUsers.concat(g.users));
                }
                this.allUsers = this.filterUniqueUsers(this.allUsers);
                this.allUsers.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);

                this.notSubmittedDataCorrectionIndexes = this.defaultSort(data.filter(a => a.status == DataCorrectionInstanceStatus.NotSubmitted));
                this.pendingReviewDataCorrectionIndexes = this.defaultSort(data.filter(a => a.status == DataCorrectionInstanceStatus.PendingReview && this.authService.User.groups.some(b => b == a.entityReviewGroupId)));
                this.approvedDataCorrectionIndexes = this.defaultSort(data.filter(a => a.status == DataCorrectionInstanceStatus.Approved && this.authService.User.groups.some(b => b == a.entityReviewGroupId)));
                this.returnedDataCorrectionIndexes = this.defaultSort(data.filter(a => a.status == DataCorrectionInstanceStatus.ReturnedForCorrections && this.authService.User.groups.some(b => b == a.entityReviewGroupId)));
                this.deniedDataCorrectionIndexes = this.defaultSort(data.filter(a => a.status == DataCorrectionInstanceStatus.Denied && this.authService.User.groups.some(b => b == a.entityReviewGroupId)));

                const pendingGroupIds = new Set(this.pendingReviewDataCorrectionIndexes.map(r => r.entityReviewGroupId));
                this.filteredUsers = this.buildUserList(this.groups.filter(g => pendingGroupIds.has(g.id)));

                if (this.pendingReviewGridApi) {
                    this.pendingReviewGridApi.setGridOption("columnDefs", []);
                    this.pendingReviewGridApi.setGridOption("columnDefs", this.buildColumns());
                }
            },
            error: (error) => {
                console.error(error);
            },
            complete: () => {
                this.showLoadingOverlays(false);
            }
        });

        this.subscriptions.add(sub$);
    }

    showLoadingOverlays(show: boolean): void {

        if (this.notSubmittedGridApi) {
            if (show) {
                this.notSubmittedGridApi.setGridOption("rowData", []);
				this.notSubmittedGridApi.setGridOption("loading", true);
            }
            else
				this.notSubmittedGridApi.setGridOption("loading", false);
        }

        if (this.pendingReviewGridApi) {
            if (show) {
				this.pendingReviewGridApi.setGridOption("rowData", []);
				this.pendingReviewGridApi.setGridOption("loading", true);
            }
            else
				this.pendingReviewGridApi.setGridOption("loading", false);
        }
    }

    get user(): UserIdentity {
        return this.authService.User;
    }

    get workOrderCreator(): Contact {
        var contact = new Contact();
        if (!this.selectedItem.creator)
            contact.firstName = 'System';
        else
            contact = this.selectedItem.creator;
        return contact;
    }
}
